@if (priority()) {
  <div class="badge border-radius-sm"
       [ngClass]="priorityBadgeClass()">
    {{priorityText() | messageTranslate}}
  </div>
}
